export function downloadBlob(blob: Blob, filename: string) {
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  a.click();
  URL.revokeObjectURL(url);
}

export function downloadCsv(
  rows: Record<string, unknown>[],
  filename: string,
  headerRenames?: Record<string, string>
) {
  if (rows.length === 0) return;
  const headers = Object.keys(rows[0]);
  const displayHeaders = headers.map((h) => headerRenames?.[h] ?? h);
  const csvRows = rows.map((row) => headers.map((h) => JSON.stringify(row[h] ?? '')).join(','));
  const csv = [displayHeaders.join(','), ...csvRows].join('\n');
  const blob = new Blob([csv], {type: 'text/csv'});
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  a.click();
  URL.revokeObjectURL(url);
}
